// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import Resumin__AccordionController from "./accordion_controller";
application.register("resumin--accordion", Resumin__AccordionController);

import Resumin__AutoSaveController from "./auto_save_controller";
application.register("resumin--auto-save", Resumin__AutoSaveController);

import Resumin__AddressController from "./address_controller";
application.register("resumin--address", Resumin__AddressController);

import Resumin__Bridge__BackButtonController from "./bridge/back_button_controller";
application.register(
  "resumin--bridge--back-button",
  Resumin__Bridge__BackButtonController,
);

import Resumin__Bridge__EventTrackingController from "./bridge/event_tracking_controller";
application.register(
  "resumin--bridge--event-tracking",
  Resumin__Bridge__EventTrackingController,
);

import Resumin__Bridge__InAppReviewController from "./bridge/in_app_review_controller";
application.register(
  "resumin--bridge--in-app-review",
  Resumin__Bridge__InAppReviewController,
);

import Resumin__Bridge__UserIdentificationController from "./bridge/user_identification_controller";
application.register(
  "resumin--bridge--user-identification",
  Resumin__Bridge__UserIdentificationController,
);

import Resumin__CareerSupportEntriesController from "./career_support_entries_controller";
application.register(
  "resumin--career-support-entries",
  Resumin__CareerSupportEntriesController,
);

import Resumin__CareerSupportPartnersController from "./career_support_partners_controller";
application.register(
  "resumin--career-support-partners",
  Resumin__CareerSupportPartnersController,
);

import Resumin__DispatchEventController from "./dispatch_event_controller";
application.register("resumin--dispatch-event", Resumin__DispatchEventController);

import Resumin__DatePickerController from "./date_picker_controller";
application.register("resumin--date-picker", Resumin__DatePickerController);

import Resumin__DisableButtonOnSubmitController from "./disable_button_on_submit_controller";
application.register(
  "resumin--disable-button-on-submit",
  Resumin__DisableButtonOnSubmitController,
);

import Resumin__DropdownController from "./dropdown_controller";
application.register("resumin--dropdown", Resumin__DropdownController);

import Resumin__EditableTitleController from "./editable_title_controller";
application.register(
  "resumin--editable-title",
  Resumin__EditableTitleController,
);

import Resumin__EmailAutocompleteController from "./email_autocomplete_controller";
application.register(
  "resumin--email-autocomplete",
  Resumin__EmailAutocompleteController,
);

import Resumin__EnableOnCheckController from "./enable_on_check_controller";
application.register(
  "resumin--enable-on-check",
  Resumin__EnableOnCheckController,
);

import Resumin__EntryEmailComposeController from "./entry_email_compose_controller";
application.register(
  "resumin--entry-email-compose",
  Resumin__EntryEmailComposeController,
);

import Resumin__EntryMailPaymentController from "./entry_mail_payment_controller";
application.register(
  "resumin--entry-mail-payment",
  Resumin__EntryMailPaymentController,
);

import Resumin__EntrySheetMailerController from "./entry_sheet_mailer_controller";
application.register(
  "resumin--entry-sheet-mailer",
  Resumin__EntrySheetMailerController,
);

import Resumin__FloatButtonController from "./float_button_controller";
application.register("resumin--float-button", Resumin__FloatButtonController);

import Resumin__FormAdditionController from "./form_addition_controller";
application.register("resumin--form-addition", Resumin__FormAdditionController);

import Resumin__FormButtonToggleController from "./form_button_toggle_controller";
application.register(
  "resumin--form-button-toggle",
  Resumin__FormButtonToggleController,
);

import Resumin__FormDuplicationController from "./form_duplication_controller";
application.register(
  "resumin--form-duplication",
  Resumin__FormDuplicationController,
);

import Resumin__FormNavigationController from "./form_navigation_controller";
application.register(
  "resumin--form-navigation",
  Resumin__FormNavigationController,
);

import Resumin__FormRemovalController from "./form_removal_controller";
application.register("resumin--form-removal", Resumin__FormRemovalController);

import Resumin__FormSubmitController from "./form_submit_controller";
application.register("resumin--form-submit", Resumin__FormSubmitController);

import Resumin__FormValueSwitchController from "./form_value_switch_controller";
application.register(
  "resumin--form-value-switch",
  Resumin__FormValueSwitchController,
);

import Resumin__GtagCustomEventOnSupportModalController from "./gtag_custom_event_on_support_modal_controller";
application.register(
  "resumin--gtag-custom-event-on-support-modal",
  Resumin__GtagCustomEventOnSupportModalController,
);

import Resumin__ImageConversionPreviewController from "./image_conversion_preview_controller";
application.register(
  "resumin--image-conversion-preview",
  Resumin__ImageConversionPreviewController,
);

import Resumin__ImageLoadingAnimationController from "./image_loading_animation_controller";
application.register(
  "resumin--image-loading-animation",
  Resumin__ImageLoadingAnimationController,
);

import Resumin__ImagePreviewController from "./image_preview_controller";
application.register("resumin--image-preview", Resumin__ImagePreviewController);

import Resumin__LacottoLinksController from "./lacotto_links_controller";
application.register("resumin--lacotto-links", Resumin__LacottoLinksController);

import Resumin__LicenseExampleCopyController from "./license_example_copy_controller";
application.register(
  "resumin--license-example-copy",
  Resumin__LicenseExampleCopyController,
);

import Resumin__LocationController from "./location_controller";
application.register("resumin--location", Resumin__LocationController);

import Resumin__ModalController from "./modal_controller";
application.register("resumin--modal", Resumin__ModalController);

import Resumin__MoreController from "./more_controller";
application.register("resumin--more", Resumin__MoreController);

import Resumin__NavBarController from "./nav_bar_controller";
application.register("resumin--nav-bar", Resumin__NavBarController);

import Resumin__OptionalController from "./optional_controller";
application.register("resumin--optional", Resumin__OptionalController);

import Resumin__PanelSwitcherController from "./panel_switcher_controller";
application.register(
  "resumin--panel-switcher",
  Resumin__PanelSwitcherController,
);

import Resumin__PasswordValidationController from "./password_validation_controller";
application.register(
  "resumin--password-validation",
  Resumin__PasswordValidationController,
);

import Resumin__PasswordVisibilityController from "./password_visibility_controller";
application.register(
  "resumin--password-visibility",
  Resumin__PasswordVisibilityController,
);

import Resumin__PdfDownloadController from "./pdf_download_controller";
application.register("resumin--pdf-download", Resumin__PdfDownloadController);

import Resumin__PopoverController from "./popover_controller";
application.register("resumin--popover", Resumin__PopoverController);

import Resumin__PreventActionController from "./prevent_action_controller";
application.register(
  "resumin--prevent-action",
  Resumin__PreventActionController,
);

import Resumin__PreventEnterController from "./prevent_enter_controller";
application.register("resumin--prevent-enter", Resumin__PreventEnterController);

import Resumin__ResizeTextareaController from "./resize_textarea_controller";
application.register(
  "resumin--resize-textarea",
  Resumin__ResizeTextareaController,
);

import Resumin__ResupriRadioButtonController from "./resupri_radio_button_controller";
application.register(
  "resumin--resupri-radio-button",
  Resumin__ResupriRadioButtonController,
);

import Resumin__SaveAndReturnHomeController from "./save_and_return_home_controller";
application.register(
  "resumin--save-and-return-home",
  Resumin__SaveAndReturnHomeController,
);

import Resumin__SelfPromotionExampleCopyController from "./self_promotion_example_copy_controller";
application.register(
  "resumin--self-promotion-example-copy",
  Resumin__SelfPromotionExampleCopyController,
);

import Resumin__SkillSheetBuildFormController from "./skill_sheet_build_form_controller";
application.register(
  "resumin--skill-sheet-build-form",
  Resumin__SkillSheetBuildFormController,
);

import Resumin__SkillSheetJobHistoriesController from "./skill_sheet_job_histories_controller";
application.register(
  "resumin--skill-sheet-job-histories",
  Resumin__SkillSheetJobHistoriesController,
);

import Resumin__SkillSheetMailerController from "./skill_sheet_mailer_controller";
application.register(
  "resumin--skill-sheet-mailer",
  Resumin__SkillSheetMailerController,
);

import Resumin__SkillSheetProfileNameCopyController from "./skill_sheet_profile_name_copy_controller";
application.register(
  "resumin--skill-sheet-profile-name-copy",
  Resumin__SkillSheetProfileNameCopyController,
);

import Resumin__SkillSheetSummaryController from "./skill_sheet_summary_controller";
application.register(
  "resumin--skill-sheet-summary",
  Resumin__SkillSheetSummaryController,
);

import Resumin__SortableListController from "./sortable_list_controller";
application.register("resumin--sortable-list", Resumin__SortableListController);

import Resumin__StepBarController from "./step_bar_controller";
application.register("resumin--step-bar", Resumin__StepBarController);

import Resumin__SubmitLoadingController from "./submit_loading_controller";
application.register(
  "resumin--submit-loading",
  Resumin__SubmitLoadingController,
);

import Resumin__TabController from "./tab_controller";
application.register("resumin--tab", Resumin__TabController);

import Resumin__TextCopyController from "./text_copy_controller";
application.register("resumin--text-copy", Resumin__TextCopyController);

import Resumin__TextCounterController from "./text_counter_controller";
application.register("resumin--text-counter", Resumin__TextCounterController);

import Resumin__ToastController from "./toast_controller";
application.register("resumin--toast", Resumin__ToastController);

import Resumin__ToggleInactiveController from "./toggle_inactive_controller";
application.register(
  "resumin--toggle-inactive",
  Resumin__ToggleInactiveController,
);

import Resumin__ToggleVisibilityController from "./toggle_visibility_controller";
application.register(
  "resumin--toggle-visibility",
  Resumin__ToggleVisibilityController,
);

import Resumin__VideoPlayerController from "./video_player_controller";
application.register("resumin--video-player", Resumin__VideoPlayerController);

import Resumin__HomeTabController from "./home_tab_controller";
application.register("resumin--home-tab", Resumin__HomeTabController);

import Resumin__NewCreateSectionController from "./new_create_section_controller";
application.register(
  "resumin--new-create-section",
  Resumin__NewCreateSectionController,
);

import Resumin__LoginRequiredController from "./login_required_controller";
application.register(
  "resumin--login-required",
  Resumin__LoginRequiredController,
);

import Resumin__PreviewModalController from "./preview_modal_controller";
application.register("resumin--preview-modal", Resumin__PreviewModalController);

import Resumin__TransientClassController from "./transient_class_controller";
application.register(
  "resumin--transient-class",
  Resumin__TransientClassController,
);

import Shared__HelloController from "../shared/hello_controller";
application.register("shared--hello", Shared__HelloController);
